import { render } from "./InputConfig.vue?vue&type=template&id=ba952a06&scoped=true"
import script from "./InputConfig.vue?vue&type=script&lang=js"
export * from "./InputConfig.vue?vue&type=script&lang=js"

import "./InputConfig.vue?vue&type=style&index=0&id=ba952a06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba952a06"]])

export default __exports__